._container_w8fgv_1 {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 400px;
  background: #fff; }

._feed_w8fgv_9 {
  flex: 1 1 auto;
  display: flex;
  flex-direction: column;
  overflow: hidden;
  background: #f0f3f5; }

.classic-facelift-skin ._feed_w8fgv_9 {
  background: #f7f8f8; }

._list_w8fgv_19 {
  flex: 1 1 auto;
  padding: 0;
  margin: 0;
  overflow-y: scroll; }

._loading_w8fgv_25 {
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center; }
